import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const scrollToSection = (sectionId: string) => {
    if (!isHomePage) {
      // If not on home page, navigate to home first
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Account for fixed navigation height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    scrollToSection(sectionId);
  };
  return <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50" data-id="element-214">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215">
        <div className="flex justify-between items-center h-16" data-id="element-216">
          {/* Logo/Brand */}
          <div className="flex-shrink-0" data-id="element-217">
            <Link to="/" className="text-xl font-bold text-black" data-id="element-218">
              I75 Audio & Video LLC
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8" data-id="element-219">
            {isHomePage ? <>
                <a href="#hero" onClick={e => handleNavClick(e, 'hero')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-220">
                  Home
                </a>
                <a href="#about" onClick={e => handleNavClick(e, 'about')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-221">
                  About Us
                </a>
                <a href="#services" onClick={e => handleNavClick(e, 'services')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-222">
                  Services
                </a>
                <a href="#work" onClick={e => handleNavClick(e, 'work')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-223">
                  Projects
                </a>
                <a href="#testimonials" onClick={e => handleNavClick(e, 'testimonials')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-224">
                  Testimonials
                </a>
                <a href="#contact" onClick={e => handleNavClick(e, 'contact')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-225">
                  Contact
                </a>
              </> : <>
                <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-226">
                  Home
                </Link>
                <Link to="/#about" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-227">
                  About Us
                </Link>
                <Link to="/#services" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-228">
                  Services
                </Link>
                <Link to="/#work" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-229">
                  Projects
                </Link>
                <Link to="/#testimonials" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-230">
                  Testimonials
                </Link>
                <Link to="/#contact" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-231">
                  Contact
                </Link>
              </>}
            <Link to="/blog" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-232">
              Blog
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-233">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-blue-600 focus:outline-none" aria-label="Toggle menu" data-id="element-234">
              {isMenuOpen ? <X size={24} data-id="element-235" /> : <Menu size={24} data-id="element-236" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-200" data-id="element-237">
          <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-238">
            {isHomePage ? <>
                <a href="#hero" onClick={e => handleNavClick(e, 'hero')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-239">
                  Home
                </a>
                <a href="#about" onClick={e => handleNavClick(e, 'about')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-240">
                  About Us
                </a>
                <a href="#services" onClick={e => handleNavClick(e, 'services')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-241">
                  Services
                </a>
                <a href="#work" onClick={e => handleNavClick(e, 'work')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-242">
                  Projects
                </a>
                <a href="#testimonials" onClick={e => handleNavClick(e, 'testimonials')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-243">
                  Testimonials
                </a>
                <a href="#contact" onClick={e => handleNavClick(e, 'contact')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-244">
                  Contact
                </a>
              </> : <>
                <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-245">
                  Home
                </Link>
                <Link to="/#about" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-246">
                  About Us
                </Link>
                <Link to="/#services" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-247">
                  Services
                </Link>
                <Link to="/#work" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-248">
                  Projects
                </Link>
                <Link to="/#testimonials" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-249">
                  Testimonials
                </Link>
                <Link to="/#contact" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-250">
                  Contact
                </Link>
              </>}
            <Link to="/blog" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-251">
              Blog
            </Link>
          </div>
        </div>}
    </nav>;
}